import React, { useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { EmailSpecDialog } from "@/components/pageSettings/LeadShareEmail";

const BTN = "border border-black px-2 py-1 text-[10px] uppercase tracking-widest inline-flex items-center gap-1 transition-colors duration-100 hover:bg-black hover:text-white";

// Emails the buyer's tech team the setup instructions, built from the field list saved for this delivery.
export function SetupInstructionsButton({ destId, className = BTN, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={className} onClick={() => setOpen(true)} data-testid={testId || `setup-instructions-${destId}`}>
        <PaperPlaneTilt size={11} /> Send setup instructions
      </button>
      {open && <EmailSpecDialog destId={destId} body={{ use_saved: true }} onClose={() => setOpen(false)} />}
    </>
  );
}
